import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  Layout,
  Cell,
  Text,
  Heading,
  CloseButton,
  Box,
  Image,
} from '@wix/design-system';
import s from './PopoverHelp.scss';

const GIF_LINK =
  'https://static.wixstatic.com/media/8d253e_917e7b661e524001b58142b4a9b4fb8a~mv2.gif';

type HelpCardContentProps = {
  show: boolean;
  setShow: (show: boolean) => void;
};

const HelpCardContent = ({ show, setShow }: HelpCardContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      {show && (
        <div data-hook="help-popover-content" className={s.container}>
          <Card
            controls={
              <CloseButton
                dataHook="help-popover-close-button"
                size="medium"
                skin="dark"
                onClick={() => {
                  setShow(false);
                }}
              />
            }
          >
            <Layout cols={1} gap={6}>
              <Box padding="18px 0px 18px 24px" direction="vertical">
                <Cell>
                  <Heading size="large">
                    {t('get_feedback_user_help_title')}
                  </Heading>
                </Cell>
                <Cell>
                  <Text skin="standard">
                    {t('get_feedback_user_help_description')}
                  </Text>
                </Cell>
              </Box>
              <Cell>
                <Box
                  padding="24px 41px"
                  backgroundColor="#DFE5EB"
                  borderBottomLeftRadius="8px"
                  borderBottomRightRadius="8px"
                >
                  <Image
                    src={GIF_LINK}
                    width="518px"
                    height="284px"
                    className={s.gif}
                  />
                </Box>
              </Cell>
            </Layout>
          </Card>
        </div>
      )}
    </>
  );
};

export default HelpCardContent;
